import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  version: "1.1",
  id: "__Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  width: "45px",
  height: "45px",
  viewBox: "0 0 45 45",
  style: {"enable-background":"new 0 0 45 45"},
  "xml:space": "preserve"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), { type: "text/css" }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode(".__st0{fill:none}.__st1{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10}.__st2{fill:#231F20}.__st3{fill:#121319}")
      ])),
      _: 1
    })),
    _cache[1] || (_cache[1] = _createStaticVNode("<g id=\"__Group_1755_1_\" transform=\"translate(15152.836 -250)\"><g id=\"__Group_1723_1_\" transform=\"translate(-13934.786 157.475)\"><path d=\"M-1189.48,133.52h-12.24c-1.53,0-2.77-1.24-2.77-2.77v-29.4h17.78v29.4C-1186.71,132.28-1187.95,133.52-1189.48,133.52z\r\n\t\t\t M-1202.49,103.36v27.4c0,0.42,0.35,0.77,0.77,0.77h12.24c0.42,0,0.77-0.35,0.77-0.77v-27.4H-1202.49z\"></path><polygon points=\"-1198.68,102.03 -1200.68,102.03 -1200.68,96.52 -1190.52,96.52 -1190.52,101.94 -1192.52,101.94 -1192.52,98.52 \r\n\t\t\t-1198.68,98.52 \t\t\"></polygon><rect x=\"-1203.75\" y=\"124.83\" transform=\"matrix(0.9662 -0.2578 0.2578 0.9662 -72.8445 -303.9388)\" width=\"16.42\" height=\"2\"></rect><rect x=\"-1203.75\" y=\"116.9\" transform=\"matrix(0.9662 -0.2578 0.2578 0.9662 -70.8 -304.2068)\" width=\"16.42\" height=\"2\"></rect><rect x=\"-1203.75\" y=\"108.97\" transform=\"matrix(0.9662 -0.2578 0.2578 0.9662 -68.7558 -304.4748)\" width=\"16.42\" height=\"2\"></rect></g></g>", 1))
  ]))
}
export default { render: render }